import React from "react";
import { useLang } from "../LangContext";

interface Props {
  onClose: () => void;
}

export default function AboutOverlay({ onClose }: Props) {
  const { t } = useLang();

  const sections = [
    { title: t.aboutWorkingHoursTitle, body: t.aboutWorkingHoursBody },
    { title: t.aboutBookingLinkTitle, body: t.aboutBookingLinkBody },
    { title: t.aboutCalendarTitle, body: t.aboutCalendarBody },
    { title: t.aboutAppointmentsTitle, body: t.aboutAppointmentsBody },
  ];

  return (
    <div className="profile-overlay">
      <div className="profile-overlay-backdrop" onClick={onClose} />
      <div className="profile-overlay-content about-overlay-content">
        <div className="profile-overlay-header">
          <h3>{t.aboutHeading}</h3>
          <button className="close-button" onClick={onClose} aria-label={t.closeAbout}>
            ×
          </button>
        </div>
        <div className="about-sections">
          {sections.map((s) => (
            <div key={s.title} className="about-section">
              <h4 className="about-section-title">{s.title}</h4>
              <p className="about-section-body">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
